import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";
import { managementActions } from "../../store/action-creators";

export const getDynamicsMappingFieldsThunk =
    () => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.dynamics.getMappingFieldsAsync.request());

            const response = await deps.si.api.management.getDynamicsMappingFields();
            dispatch(managementActions.dynamics.getMappingFieldsAsync.success(response));
        } catch (error) {
            dispatch(managementActions.dynamics.getMappingFieldsAsync.failure(error));
        }
    };

export const putDynamicsFilterFieldsThunk =
    (fields: string[]) =>
    async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies): Promise<boolean> => {
        try {
            dispatch(managementActions.dynamics.putFilterFieldsAsync.request());
            const { value } = await deps.si.api.management.putDynamicsFilterFields(fields);
            if (value) {
                await dispatch(getDynamicsMappingFieldsThunk());
                dispatch(managementActions.dynamics.putFilterFieldsAsync.success(value));
            }
            return value;
        } catch (error) {
            dispatch(managementActions.dynamics.putFilterFieldsAsync.failure(error));
            return false;
        }
    };
